import { render, staticRenderFns } from "./DynamicCatalogAddButton.vue?vue&type=template&id=11f508c3&scoped=true"
import script from "./DynamicCatalogAddButton.vue?vue&type=script&lang=js"
export * from "./DynamicCatalogAddButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11f508c3",
  null
  
)

export default component.exports